import template from './version-upgrade-modal.html';
import {SIZE_MEDIUM} from '../../modal/modal-service';

VersionUpgrade.DIRECTIVE_NAME = 'ktVersionUpgrade';
export default function VersionUpgrade() {
    return {
        restrict: 'A',
        controller: VersionUpgradeController,
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

function VersionUpgradeController(
    $http,
    $timeout,
    $window,
    modalService,
    localStorageService,
) {
    'ngInject';

    const vm = this;
    const REFRESH_MIN = 5;
    const HEADER_TO_CHECK = 'Last-Modified';
    const LOCAL_STORAGE_KEY = 'kt-online-reload';

    let runningVersion = null;
    let warningShown = false;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        setNewVersionIsLoadedFlag();
        checkVersionNow(true);
        checkVersionLittleLater();
        waitTillUserAgreesToUpgradeTheApplication();
    }

    function checkVersionLittleLater() {
        setTimeout(checkVersionNow, REFRESH_MIN * 60 * 1000); // eslint-disable-line
    }

    function checkVersionNow(isInitialization) {
        $http
            .head('/', {noSpinner: true})
            .then((response) => {
                const serverVersion = response.headers(HEADER_TO_CHECK) || runningVersion;
                if (!runningVersion) {
                    runningVersion = serverVersion;
                }
                if (isInitialization) {
                    return;
                }
                if (runningVersion === serverVersion) {
                    checkVersionLittleLater();
                } else {
                    showWarning();
                }
            });
    }

    function showWarning() {
        if (warningShown) {
            return;
        }
        warningShown = true;
        modalService
            .openModal({
                size: SIZE_MEDIUM,
                template,
            })
            .result
            .then(() => {
                informAllTabsToReload();
                reloadApplication();
            })
            .finally(() => warningShown = false);
    }

    function informAllTabsToReload() {
        localStorageService.set(LOCAL_STORAGE_KEY, true);
    }

    function setNewVersionIsLoadedFlag() {
        localStorageService.remove(LOCAL_STORAGE_KEY);
    }

    function reloadApplication() {
        $window.location.reload();
    }

    function waitTillUserAgreesToUpgradeTheApplication() {
        const LS_KEY = `ls.${LOCAL_STORAGE_KEY}`;
        $window.addEventListener('storage', ({key, newValue}) => {
            if (key === LS_KEY && newValue === 'true') {
                reloadApplication();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/version-upgrade/version-upgrade-directive.js